(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal','$stateParams','$http','$timeout','$window'];

    function PasswordController (Auth, Principal,$stateParams,$http,$timeout,$window) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.errorOldPassword = null;
        vm.errorPPolicy = null;
        vm.errorPSync = null;
        vm.us_account=$stateParams.us_account;
        vm.escapeSingleQuote = escapeSingleQuote;
        vm.accounts = null;
        vm.showPassword=[false,false,false];
        vm.toggleShowPassword=toggleShowPassword;

        if(vm.us_account){
        	vm.account = {};
        	getUserName();
        	
        }else{
	        Principal.identity().then(function(account) {
	            vm.account = account;
	        });
        }
        
        function getUserName(){
        	$http.get('api/account/whois',{
        	    params: {us_account: vm.us_account}
        	 }).then(function(result) {
                
        		if(result.status == 200){
        			vm.account = result.data;
        		}
                
            });

        };
        
        function goToAuth(){
        	$window.location.href = 'auth/'; 
        }

        function changePassword () {
            vm.error = null;
            vm.success = null;
            vm.doNotMatch = null;
            vm.errorPPolicy = null;
            vm.errorPSync = null;
            vm.errorOldPassword = null;
            if (vm.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
            	vm.accounts = null;
            	vm.sending = true;
                Auth.changePassword(vm.oldPassword,vm.password,vm.us_account).then(function (response) {
                	vm.sending = false;
                	vm.success = 'OK';
                	if (response && response.data) {
                		vm.accounts = response.data.split('<br />');
                	}
                	//scrolliamo per mostrare i messaggi
                	window.scrollTo(0,0)
                    if($stateParams.us_account!=null){
                    	$timeout(goToAuth, 10000);
                    }
                    
                }).catch(function (response) {
                	vm.sending = false;
                	if(response.data === 'IncorrectOldPassword')
                		vm.errorOldPassword = 'IncorrectOldPassword';
                	else if(response.data === 'InvalidPassword')
                		vm.errorPPolicy = 'InvalidPassword';
                	else if(response.data === 'SyncPasswordError')
                		vm.errorPSync = true;
                	else
                		vm.error = 'ERROR';
                	//scrolliamo per mostrare i messaggi
                	window.scrollTo(0,0)
                });
            }
        }
        
        function toggleShowPassword(index){
        	vm.showPassword[index]=!vm.showPassword[index];
        }
        
        function escapeSingleQuote(stringa){
        	stringa = stringa ? stringa.replace(/'/g, "\\'") : '';
        	return stringa;
        }

    }
})();
